import { DatePicker } from "@mui/x-date-pickers";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import AcaoAuditoria from "model/auditoria5s/auditoria/AcaoAuditoria";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import AcaoAuditoriaService from "service/auditoria5s/AcaoAuditoriaService";
import { converterData } from "utils/convert";
import "./AcaoAuditoriaResponderPage.scss";
import { useToastContext } from "components/alert/ToastContext";

const acaoAuditoriaService = new AcaoAuditoriaService();
function AcaoAuditoriaResponderPage() {

    const [acao, setAcao] = useState<AcaoAuditoria>(new AcaoAuditoria());
    const { startLoading, stopLoading } = useLoadingContext();

    const navigate = useNavigate();

    const { msgSucesso, msgErro } = useToastContext();

    useEffect(() => {
        const id = window.location.pathname.substring(`/minhasAcoesAuditoria/`.length)
        startLoading();
        acaoAuditoriaService.consultarMinha(Number(id)).then((acao) => {
            console.log(acao);
            setAcao(acao);
        }).catch(e => {
            msgErro("Erro", e.data?.message || "Não foi possível carregar a ação");
            console.log(e);
        }).finally(() => {
            stopLoading();
        })
    }, []);

    function gravarAcao() {
        startLoading();
        acaoAuditoriaService.salvarAcao(acao).then(() => {
            voltarParaLista();
        }).catch(e => {
            msgErro("Erro", e.data?.message || "Não foi possível salvar a ação");
            console.log(e);
        }).finally(() => {
            stopLoading();
        })
    }

    function voltarParaLista() {
        navigate("/minhasAcoesAuditoria");
    }

    return (
        <div>
            <div className="card-item">
                <span style={{ fontWeight: 'bold', fontSize: 18, paddingBottom: 4 }}>Ação: {acao.nome}</span>
                <span style={{ fontSize: 16, paddingBottom: 4 }}>Número da auditoria: {acao?.itemAuditoria?.classeAuditoria?.auditoria?.numero || ""}</span>
                <span style={{ fontSize: 16, paddingBottom: 4 }}>Auditoria: {acao?.itemAuditoria?.classeAuditoria?.auditoria?.nome || ""}</span>
                <span style={{ fontSize: 16, paddingBottom: 4 }}>Setor: {acao?.itemAuditoria?.classeAuditoria?.auditoria?.setor?.nome || ""}</span>
                <span style={{ fontSize: 16, paddingBottom: 4 }}>Data geração: {converterData(acao.createdAt)}</span>

            </div>

            <div className="card-item">
                <Label style={{ paddingBottom: 4 }}>Comentário</Label>
                <InputTextarea
                    readOnly
                    style={{ height: 80 }}
                    rows={4}
                    value={acao.descricao} />
            </div>

            <div className="card-item">
                <Label style={{ paddingBottom: 4 }}>Data limite</Label>
                <DatePicker
                    value={dayjs(acao.dataLimite)}
                    onChange={value => {
                        setAcao({ ...acao, dataLimite: value?.toDate() || null })
                    }}
                />
            </div>

            <div className="card-item">
                <Label style={{ paddingBottom: 4 }}>Resposta</Label>
                <InputTextarea
                    style={{ height: 80 }}
                    rows={4}
                    placeholder='Resposta'
                    value={acao.resposta}
                    onChange={(e) => {
                        acao.resposta = e.target.value;
                        setAcao({ ...acao });
                    }} />
            </div>

            <div className="card-item">
                <Label style={{ paddingBottom: 4 }}>Status</Label>
                <Dropdown
                    placeholder='Selecione o status'
                    value={acao.status}
                    onChange={e => {
                        acao.status = e.target.value;
                        setAcao({ ...acao });
                    }}
                    options={[
                        { label: 'Criado', value: 'CRIADO' },
                        { label: 'Em andamento', value: 'EM_ANDAMENTO' },
                        { label: 'Finalizado', value: 'FINALIZADO' }
                    ]}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                <Button style={{ marginLeft: 8, marginRight: 8 }} onClick={() => {
                    voltarParaLista();
                }}>
                    Voltar
                </Button>
                <Button style={{ marginLeft: 8, marginRight: 8 }} onClick={() => {
                    gravarAcao();
                }}>
                    Gravar ação
                </Button>
            </div>

        </div>

    );
}

export default AcaoAuditoriaResponderPage;

